import { useNotificationStore } from '@/stores/notificationStore'

export function useBillingPortalErrorNotification() {
  const route = useRoute()
  const router = useRouter()
  const notificationStore = useNotificationStore()

  onMounted(async () => {
    if (route.query.billingPortalError !== '1') return

    notificationStore.addError(
      "We couldn't open billing management right now. Please contact support.",
      true
    )

    const { billingPortalError, ...query } = route.query
    await router.replace({ query })
  })
}
